var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.$vuetify.breakpoint.smAndDown ? [_c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('TxParamsDialog', {
    on: {
      "change": _vm.emitChange
    }
  }), _c('TxFilterDialog', {
    attrs: {
      "chains": _vm.chains
    },
    on: {
      "change": _vm.setFilter
    }
  })], 1)]), !_vm.loading && _vm.assetsLoaded ? _c('TxList', {
    attrs: {
      "transactions": _vm.filteredTransactions
    }
  }) : _c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })] : [_c('TxParams', {
    on: {
      "change": _vm.emitChange
    }
  }), _c('div', {
    staticClass: "two-col"
  }, [_c('TxFilter', {
    attrs: {
      "chains": _vm.chains
    },
    on: {
      "change": _vm.setFilter
    }
  }), _c('div', {
    staticClass: "right"
  }, [!_vm.loading && _vm.assetsLoaded ? _c('TxList', {
    attrs: {
      "transactions": _vm.filteredTransactions
    }
  }) : _c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1)], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }